module.exports = __webpack_public_path__ + "static/media/c-pop-up-2.6db07caf.png";